import { AuthContext, IAuthContext } from './../contexts/AuthContext';
import { useContext } from "react"

export const useAuth = ():IAuthContext => {
    return useContext(AuthContext)
}